<div class="grid">
  <div class="col-12">
    <div class="mb-5">
      <p-breadcrumb [model]="breadcrumbItems" [home]="home"></p-breadcrumb>
    </div>
  </div>

  <div class="col-12">
    <div class="card shadow-2">
      <users-table [data]="users$ | async" />
    </div>
  </div>
</div>
